import { customFetch } from 'utils/http';
import { HTTPResponseError, PartnerNotFoundError } from 'utils/errors';
import { M8PartnerDTO } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  partnerCode: string;
};

export const getPartnerByCode = async (
  params: Params
): Promise<M8PartnerDTO> => {
  const fetchURL = getM8UserURL(
    `getPartnerByCode?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 204) {
    throw new PartnerNotFoundError();
  }

  return response.json();
};
